import React from "react";

import { Select, SelectChip, TextField, VerifyBank } from "components";
import { Slide } from "react-reveal";

export default function OwnAccount({
  errorAmt,
  errorText,
  handleAmtChange,
  accounts,
  setBankDetails,
  bankDetails,
  amount,
  isSubmitting,
  label,
}) {
  return (
    <>
      <VerifyBank
        {...{ bankDetails, setBankDetails, accounts, label, isSubmitting }}
        accountType="own-account"
      />

      <div className="col-span-1">
        <SelectChip
          title="Select Amount"
          list={["5000", "10000", "20000", "50000", "100000"]}
          handleClick={(amt) => handleAmtChange(amt)}
          currData={amount}
        />
      </div>

      <div className="col-span-1">
        <TextField
          name="amount"
          type="text"
          label="Amount"
          // value={formatInputNum(amount)}
          value={amount}
          handleChange={handleAmtChange}
          startAdornment="₦"
          formatInput
          disableAutoComplete
          // error={errorAmt === true}
          // showError={errorAmt === true}
          // helperText={errorText}
          placeholder="0.00"
        />
        {errorAmt && (
          <Slide down duration={300}>
            <div className="mt-2 text-xs font-normal text-red-500">
              {errorText}
            </div>
          </Slide>
        )}
      </div>
    </>
  );
}
